module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: {
      'crud-field': true, 'saved': _vm.displaySaved
    }
  }, [(!_vm.editing) ? _c('div', {
    on: {
      "click": _vm.edit
    }
  }, [(!_vm.options.type || _vm.options.type === 'text' || _vm.options.type === 'number') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.textDisplay) + " " + _vm._s(_vm.value[_vm.field] !== undefined && _vm.value[_vm.field] !== null && _vm.value[_vm.field] !== '' ? _vm.options.unit : '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'bool') ? _c('span', [_c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "disabled": !_vm.editable || !_vm.options.editable
    },
    on: {
      "change": _vm.boolChange
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.type === 'color') ? _c('span', [(_vm.value[_vm.field]) ? _c('div', {
    staticClass: "color-rect",
    style: (("background-color: " + (_vm.value[_vm.field])))
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'interval') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value[_vm.field] && _vm.formatInterval(_vm.value[_vm.field])) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'date') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value[_vm.field] && _vm.formatDate(_vm.value[_vm.field])) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'enum') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.options.values[_vm.value[_vm.field]] || _vm.value[_vm.field]) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'reference') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value[_vm.field] && _vm.value[_vm.field][_vm.options.display || 'name']) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'references') ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: _vm.formatReferencesTooltip(_vm.references)
      }),
      expression: "{ content: formatReferencesTooltip(references) }"
    }]
  }, [_vm._v("\n       " + _vm._s(_vm.formatReferences(_vm.references)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'data') ? _c('span', _vm._l((_vm.dataChange), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e()]) : _c('div', [_c('form', {
    staticClass: "sm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveField($event)
      }
    }
  }, [_c('crud-input', {
    ref: "field",
    attrs: {
      "field": _vm.field,
      "options": _vm.options,
      "focus": true,
      "size": "sm"
    },
    on: {
      "save": _vm.save
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-actions elevation-1"
  }, [_c('v-btn', {
    staticClass: "inaction ma-0 pa-0",
    attrs: {
      "icon": "",
      "flat": "",
      "size": "sm",
      "danger": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "inaction ma-0 pa-0",
    attrs: {
      "icon": "",
      "flat": "",
      "size": "sm",
      "success": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-708bf7a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crud/CrudField.vue
// module id = 1083
// module chunks = 1